/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_Case_Exception_InvalidInputs */

const en_api_error_case_exception_invalid = /** @type {(inputs: Api_Error_Case_Exception_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The review task is not a valid completed exception decision.`)
};

const pt_br2_api_error_case_exception_invalid = /** @type {(inputs: Api_Error_Case_Exception_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A tarefa de revisão não contém uma decisão válida e concluída sobre a exceção.`)
};

/**
* | output |
* | --- |
* | "The review task is not a valid completed exception decision." |
*
* @param {Api_Error_Case_Exception_InvalidInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const api_error_case_exception_invalid = /** @type {((inputs?: Api_Error_Case_Exception_InvalidInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_Case_Exception_InvalidInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_case_exception_invalid(inputs)
	return pt_br2_api_error_case_exception_invalid(inputs)
});